<div>
  @switch (control) {
    @case ('button') {
      <button
        type="button"
        class="soft-button secondary"
        (click)="onClick()"
        >
        <soft-dynamic-value
          [value]="context"
          [definition]="definition"
        ></soft-dynamic-value>
      </button>
    }
    @default {
      <a (click)="onClick()" class="soft-link">
        <soft-dynamic-value
          [value]="context"
          [definition]="definition"
        ></soft-dynamic-value>
      </a>
    }
  }
</div>
